<template>
  <header class="header1">
    <!-- BOTTOM BAR -->
    <nav class="navbar navbar-default logo-infos" id="modeltheme-main-head">
      <div class="container">
        <div class="row">
          <!-- LOGO -->
          <div class="navbar-header col-md-12 col-lg-2">
            <!-- NAVIGATION BURGER MENU -->
            <button
              type="button"
              class="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#navbar"
              aria-expanded="false"
              aria-controls="navbar"
            >
              <span class="sr-only"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <h1 class="logo">
              <a href="http://staging.clearmeout.com/">
                <img class="img-responsive" src="../../assets/images/logo.png" alt="ClearMeOut" />
              </a>
            </h1>
          </div>
          <!-- NAV MENU -->
          <div id="navbar" class="navbar-collapse collapse col-md-12 col-lg-10">
            <ul class="menu nav navbar-nav pull-right nav-effect nav-menu">
              <li class="menu-item menu-item-type-post_type menu-item-object-page">
                <a href="/">Home</a>
              </li>
              <li class="menu-item menu-item-type-post_type menu-item-object-page">
                <a href="/personal">Personal</a>
              </li>
              <li class="menu-item menu-item-type-post_type menu-item-object-page">
                <a href="/business">Business</a>
              </li>
              <li class="menu-item menu-item-type-post_type menu-item-object-page">
                <a href="/pricing">Plans &amp; Pricing</a>
              </li>
              <li
                class="menu-item menu-item-type-custom menu-item-object-custom current-menu-item menu-item-home current-menu-ancestor current-menu-parent menu-item-has-children"
              >
                <a href="void:function(0)">Support</a>
                <ul class="sub-menu">
                  <li
                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-30 current_page_item"
                  >
                    <a href="/support">Support Centre</a>
                  </li>
                  <li class="menu-item menu-item-type-post_type menu-item-object-page">
                    <a href="/faq">FAQ</a>
                  </li>
                </ul>
              </li>
              <li class="menu-item menu-item-type-post_type menu-item-object-page">
                <a href="/blog">Blog</a>
              </li>
              <li
                class="menu-item menu-item-type-custom menu-item-object-custom current-menu-item menu-item-home current-menu-ancestor current-menu-parent menu-item-has-children"
              >
                <a href="/support">Company</a>
                <ul class="sub-menu">
                  <li
                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-30 current_page_item"
                  >
                    <a href="/about">About Us</a>
                  </li>
                  <li class="menu-item menu-item-type-post_type menu-item-object-page">
                    <a href="/technology">Technology</a>
                  </li>
                  <li class="menu-item menu-item-type-post_type menu-item-object-page">
                    <a href="/contact-us">Contact Us</a>
                  </li>
                </ul>
              </li>
              <li
                class="menu-item menu-item-type-custom menu-item-object-custom current-menu-item menu-item-home current-menu-ancestor current-menu-parent menu-item-has-children"
              >
                <a href="void:function(0)">Sign In</a>
                <ul class="sub-menu">
                  <li
                    class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-30 current_page_item"
                  >
                    <a href="/personal_sign_in">Personal</a>
                  </li>
                  <li class="menu-item menu-item-type-post_type menu-item-object-page">
                    <a href="/business_sign_in">Business</a>
                  </li>
                </ul>
              </li>
              <li class="menu-item menu-item-type-post_type menu-item-object-page" style="pointer-events: none!important;">
                <a href="void:function(0)">&nbsp;</a>
              </li>
              <!-- MT BURGER
              <li class="mt-nav-burger-li" id="mt-nav-burger">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </li> -->
            </ul>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue